import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

const fmtAxis = (val) => {
  if (val >= 1000) return `$${Math.round(val / 1000)}k`;
  return `$${val}`;
};

const fmtFull = (val) =>
  `$${parseFloat(val || 0).toLocaleString("en-AU", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-[#E6E9EF] bg-white px-3 py-2 shadow-lg">
      <p className="text-[11px] font-semibold text-[#0C1120]">{label}</p>
      <p className="text-[13px] font-bold text-[#28C0D0]" style={{ fontFamily: "Poppins,sans-serif" }}>
        {fmtFull(payload[0].value)}
      </p>
    </div>
  );
};

const DashboardRevenueChart = ({ monthlyRevenue, maxMonthly, loading, isDark }) => {
  if (loading) return <div className="sz-card h-[300px] animate-pulse" />;

  const data = monthlyRevenue || [];
  const totalRevenue = data.reduce((sum, d) => sum + (d.amount || 0), 0);
  const peakMonth = data.reduce((max, d) => (d.amount > (max?.amount || 0) ? d : max), data[0]);

  return (
    <section className="sz-card" style={{ padding: "20px 22px" }}>
      <div className="flex items-start justify-between">
        <div>
          <h3 className="text-[15px] font-bold text-[#0C1120]" style={{ fontFamily: "Poppins,sans-serif" }}>
            Revenue Trend
          </h3>
          <div className="mt-[3px] text-[12px] text-[#8A90A2]">Monthly platform revenue · last 12 months</div>
        </div>
        <div className="text-right">
          <div className="text-[20px] font-bold text-[#0C1120]" style={{ fontFamily: "Poppins,sans-serif", letterSpacing: "-.4px" }}>
            {fmtFull(totalRevenue)}
          </div>
          {peakMonth && (
            <div className="text-[11.5px] text-[#8A90A2]">
              Peak · {peakMonth.month} {fmtAxis(peakMonth.amount)}
            </div>
          )}
        </div>
      </div>
      {data.length === 0 ? (
        <div className="flex h-[220px] items-center justify-center text-[13px] text-[#8A90A2]">
          No revenue data yet
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={220}>
          <AreaChart data={data} margin={{ top: 14, right: 6, left: -8, bottom: 0 }}>
            <defs>
              <linearGradient id="szRevFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#28C0D0" stopOpacity={0.28} />
                <stop offset="100%" stopColor="#28C0D0" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis
              dataKey="month"
              tick={{ fontSize: 10, fill: "#A8AEBC", fontFamily: "Work Sans" }}
              tickLine={false}
              axisLine={false}
            />
            <YAxis
              tickFormatter={fmtAxis}
              tick={{ fontSize: 10, fill: "#A8AEBC", fontFamily: "Work Sans" }}
              tickLine={false}
              axisLine={false}
              width={42}
            />
            <Tooltip content={<CustomTooltip />} cursor={{ stroke: "#E6E9EF" }} />
            <Area
              type="monotone"
              dataKey="amount"
              stroke="#28C0D0"
              strokeWidth={2.5}
              fill="url(#szRevFill)"
              dot={{ r: 3, fill: "#fff", stroke: "#28C0D0", strokeWidth: 2 }}
              activeDot={{ r: 4 }}
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </section>
  );
};

export default DashboardRevenueChart;
